import { Box, FormControl, InputLabel, Select, MenuItem } from '@mui/material'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

interface IActionsDropdown {
    userActionValue: string
    onClickUserActions: (action: any) => void
    availableActions: string[]
}
export const ActionsDropdown = (props: IActionsDropdown): ReactElement => {
    const { t } = useTranslation()
    const { onClickUserActions, userActionValue, availableActions } = props

    return (
        <Box display="flex" alignItems="center" sx={{ width: '160px' }}>
            <FormControl fullWidth size="small">
                <InputLabel id="actions-select-label">
                    {t('actions')}
                </InputLabel>
                <Select
                    labelId="actions-select-label"
                    id="actions-type-select"
                    value={userActionValue}
                    label={t('actions')}
                    onChange={onClickUserActions}
                    autoWidth
                    MenuProps={{
                        PaperProps: {
                            style: {
                                maxHeight: 200,
                                width: 160,
                            },
                        },
                    }}
                >
                    {availableActions.map((a) => (
                        <MenuItem key={a} value={a} id={a}>
                            {a}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
        </Box>
    )
}
